module.exports = __webpack_public_path__ + "static/media/grupo nacional provincial.8b900b94.svg";